import type { AllStreamNotification } from "@redotech/effect-api-shared/models/team/notification";
import { AllStreamNotificationJson } from "@redotech/effect-api-shared/models/team/notification";
import type { StreamTopicName } from "@redotech/effect-api-shared/models/team/stream-topic-name";
import { AuthContext } from "@redotech/redo-merchant-app-common/auth";
import { REDO_EFFECT_API_URL } from "@redotech/redo-merchant-app-common/config";
import { memo, useContext, useMemo, type ReactNode } from "react";
import { createNotificationStreamProvider } from "./notification-stream-provider";

// Create typed provider and hook for AllStreamNotification schema
const {
  Provider: BaseProvider,
  useNotificationStream: useTeamNotificationStream,
} = createNotificationStreamProvider<AllStreamNotification>();

// Export typed hook for use throughout the app
export { useTeamNotificationStream };

export const TeamNotificationStreamProvider = memo(
  function TeamNotificationStreamProvider({
    children,
    topics,
  }: {
    children: ReactNode;
    topics?: StreamTopicName[];
  }) {
    const auth = useContext(AuthContext);

    const streamUrl = useMemo(() => {
      const url = new URL(
        "/api/streams/team/notifications",
        REDO_EFFECT_API_URL,
      );
      if (topics && topics.length > 0) {
        url.searchParams.set("topics", topics.join(","));
      }
      return url.toString();
    }, [topics]);

    return (
      <BaseProvider
        schema={AllStreamNotificationJson}
        token={auth?.token}
        url={streamUrl}
      >
        {children}
      </BaseProvider>
    );
  },
);
